import { motion } from "framer-motion";
import { springPresets, staggerContainer, staggerItem } from "@/lib/motion";

const NEWS_ITEMS = [
  {
    id: 1,
    category: "TÖRENDE",
    badge: "🏛️",
    headline: "TBMM'de Çocuklar Koltuğa Oturdu!",
    lead: "Her yıl 23 Nisan'da Türkiye Büyük Millet Meclisi, çocuklara kapılarını açıyor. Küçük 'milletvekilleri' söz alarak hayallerini ve beklentilerini dile getiriyor.",
    body: "Bu özel oturumda çocuklar gerçek milletvekili koltuklarına oturarak oylamaya katılıyor. 'Makam Devri' geleneği Atatürk'ün çocuklara karşı duyduğu büyük sevginin ve güvenin simgesidir.",
    quote: "Türkiye'nin küçük temsilcileri bugün meclis kürsüsünde seslerini yükseltti.",
  },
  {
    id: 2,
    category: "DÜNYA",
    badge: "🌍",
    headline: "110 Ülkeden Çocuklar Türkiye'de!",
    lead: "Bu yıl 110'dan fazla ülkeden gelen çocuklar, 23 Nisan kutlamalarına katılmak için Türkiye'ye geldi. Farklı kültürlerden çocuklar ortak bir dilde buluştu: Barış ve dostluk.",
    body: "TRT'nin 1979'da başlattığı bu güzel gelenek, her yıl büyüyerek devam ediyor. Geleneksel kıyafetleriyle gelen çocuklar, halk dansları ve müzik gösterileriyle sahne aldı.",
    quote: "Barış içinde bir dünya için çocuklar el ele...",
  },
  {
    id: 3,
    category: "TARİH",
    badge: "📜",
    headline: "O Gün Ne Oldu? 23 Nisan 1920",
    lead: "Tam 106 yıl önce, 23 Nisan 1920'de Ankara'da tarihi bir oturum gerçekleşti. Milletvekilleri dua ederek Meclis salonuna girdi ve Türk milletinin kaderini değiştiren kararlar alındı.",
    body: "Kuvay-i Milliye ruhunu taşıyan delegeler, Osmanlı'nın çöküşü ve Kurtuluş Savaşı'nın tam ortasında toplandı. Mustafa Kemal'in liderliğinde alınan kararlar, yeni bir devletin temelini attı.",
    quote: "Egemenlik kayıtsız şartsız milletindir! — Mustafa Kemal Atatürk",
  },
];

export function NewsSection() {
  return (
    <section id="kutlama-haberleri" className="py-12 px-4 bg-background">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-3xl font-black text-primary mb-2" style={{ fontFamily: "'Merriweather', serif" }}>
            📰 Haberler & Etkinlikler
          </h2>
          <p className="text-muted-foreground">23 Nisan'dan öne çıkan haberler</p>
          <div className="w-24 h-1 bg-primary mx-auto mt-3 rounded-full" />
        </div>

        <motion.div
          variants={staggerContainer}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.1 }}
          className="grid grid-cols-1 md:grid-cols-3 gap-6"
        >
          {NEWS_ITEMS.map((item, i) => (
            <motion.article
              key={item.id}
              variants={staggerItem}
              whileHover={{ y: -3 }}
              transition={springPresets.snappy}
              className={`bg-card rounded-xl border border-border overflow-hidden ${
                i === 0 ? "md:col-span-2" : ""
              }`}
              style={{ boxShadow: "0 4px 16px -4px oklch(0.48 0.24 12 / 0.10)" }}
            >
              {/* Card header */}
              <div className="bg-primary px-4 py-2 flex items-center gap-2">
                <span className="text-lg">{item.badge}</span>
                <span className="text-primary-foreground text-xs font-bold tracking-widest uppercase">
                  {item.category}
                </span>
              </div>

              <div className="p-5">
                <h3 className="text-xl font-black text-foreground mb-2 leading-snug"
                  style={{ fontFamily: "'Merriweather', serif" }}>
                  {item.headline}
                </h3>
                <p className="text-primary font-semibold text-sm mb-3 leading-relaxed">{item.lead}</p>
                <div className="w-full h-px bg-border mb-3" />
                <p className="text-muted-foreground text-sm leading-relaxed mb-4">{item.body}</p>
                <blockquote className="border-l-4 border-primary pl-4 italic text-sm text-muted-foreground bg-secondary/30 py-2 rounded-r-lg">
                  {item.quote}
                </blockquote>
              </div>
            </motion.article>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
